"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var credit_card_format_directive_1 = require("./directives/credit-card-format.directive");
var expiry_format_directive_1 = require("./directives/expiry-format.directive");
var cvc_format_directive_1 = require("./directives/cvc-format.directive");
var CREDIT_CARD_LIBRARY_DIRECTIVES = [
    credit_card_format_directive_1.CreditCardFormatDirective,
    expiry_format_directive_1.ExpiryFormatDirective,
    cvc_format_directive_1.CvcFormatDirective
];
var CreditCardDirectivesModule = (function () {
    function CreditCardDirectivesModule() {
    }
    CreditCardDirectivesModule.decorators = [
        { type: core_1.NgModule, args: [{
                    declarations: [CREDIT_CARD_LIBRARY_DIRECTIVES],
                    exports: [CREDIT_CARD_LIBRARY_DIRECTIVES]
                },] },
    ];
    CreditCardDirectivesModule.ctorParameters = function () { return []; };
    return CreditCardDirectivesModule;
}());
exports.CreditCardDirectivesModule = CreditCardDirectivesModule;
//# sourceMappingURL=directives.js.map


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src2078029388/src/~/ng-betalabs-creditcard/lib/directives.js
// module id = faKj
// module chunks = 6